import { IconMoon, IconSun } from "@tabler/icons-react";
import type { ReactElement } from "react";
import { useThemePreference } from "../styles/ThemePreferenceProvider";
import { Button } from "./Button";
import { IconControlButton } from "./rail/IconControlButton";

export interface ThemeToggleButtonProps {
  /** 40px rail-style control (viewer islands) instead of the 48px marketing Button. */
  compact?: boolean;
}

/** Sun/moon outline icon button wired to `ThemePreferenceProvider`. */
export function ThemeToggleButton({
  compact = false
}: ThemeToggleButtonProps): ReactElement {
  const { theme, toggleTheme } = useThemePreference();
  const label = theme === "dark" ? "Switch to light mode" : "Switch to dark mode";

  if (compact) {
    return (
      <IconControlButton
        icon={theme === "dark" ? IconSun : IconMoon}
        aria-label={label}
        onClick={toggleTheme}
      />
    );
  }

  return (
    <Button
      variant="outline"
      icon={theme === "dark" ? IconSun : IconMoon}
      aria-label={label}
      onClick={toggleTheme}
    />
  );
}
